/* eslint-disable @typescript-eslint/no-unused-expressions */
// Integration Task panding
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SupplierModel } from '../../models'

export interface SupplierState {
    Supplier: SupplierModel
    SuppliersList: SupplierModel[]
}

const initialState: SupplierState = {
    Supplier: {
        SupplierID: 0,
        CompanyName: '',
        ContactPerson: '',
        Email: '',
        Mobile: '',
        AlternativeNumber: '',
        GSTNo: '',
        CreditDebit : '',
        GSTType: '',
        Address: '',
        Area: '',
        City: '',
        State: '',
        Country: '',
        ZipCode: 0
    },
    SuppliersList: [],
}

export const SupplierSlice = createSlice({
    name: 'supplier',
    initialState,
    reducers: {
        setSuppliers: (state, action: PayloadAction<SupplierModel[]>) => {
            state.SuppliersList = action.payload
        },
        saveSupplier: (state, action: PayloadAction<SupplierModel>) => {
            let model = action.payload
            if (model.SupplierID > 0) {
                let defaultModel: SupplierModel = {
                    SupplierID: model.SupplierID,
                    CompanyName: model.CompanyName,
                    ContactPerson: model.ContactPerson,
                    Email: model.Email,
                    Mobile: model.Mobile,
                    AlternativeNumber: model.AlternativeNumber,
                    GSTNo: model.GSTNo,
                    CreditDebit : model.CreditDebit,
                    GSTType: model.GSTType,
                    Address: model.Address,
                    Area: model.Area,
                    City: model.City,
                    State: model.State,
                    Country: model.Country,
                    ZipCode: model.ZipCode
                }
                let currentModel = state.SuppliersList.find((c) => c.SupplierID === model.SupplierID) || defaultModel
                currentModel.CompanyName = model.CompanyName,
                currentModel.ContactPerson = model.ContactPerson,
                currentModel.Email = model.Email,
                currentModel.Mobile = model.Mobile,
                currentModel.AlternativeNumber = model.AlternativeNumber,
                currentModel.GSTNo = model.GSTNo,
                currentModel.CreditDebit = model.CreditDebit,
                currentModel.GSTType = model.GSTType,
                currentModel.Address = model.Address,
                currentModel.Area = model.Area,
                currentModel.City = model.City,
                currentModel.State = model.State,
                currentModel.Country = model.Country,
                currentModel.ZipCode = model.ZipCode
            } else {
                model.SupplierID = (Math.max(...state.SuppliersList.map((c) => c.SupplierID)) || 0) + 1
                state.SuppliersList.push(model)
            }
        },
        getSupplier: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: SupplierModel = initialState.Supplier
            if (id > 0) {
                let currentList: SupplierModel[] = state.SuppliersList
                model = currentList.find((c) => c.SupplierID === id) || initialState.Supplier
            }
            state.Supplier = model
        },
        deleteSuppliers: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentList: SupplierModel[] = state.SuppliersList
                state.SuppliersList = currentList.filter((c) => !ids.includes(c.SupplierID))
            }
        },
    },
})

export const { setSuppliers, saveSupplier, getSupplier, deleteSuppliers } =
    SupplierSlice.actions

export default SupplierSlice.reducer
